import { CommandType } from '../types/Command';

/**
 * チュートリアルターン定義
 */
export interface TutorialTurnDef {
  /** ターン番号 */
  turn: number;
  /** プレイヤーの固定コマンド */
  playerCommands: { first: CommandType; second: CommandType };
  /** 敵の固定コマンド */
  enemyCommands: { first: CommandType; second: CommandType };
  /** ポップアップメッセージ（タイトル） */
  popupMessage: string;
  /** 詳細メッセージ（仕組みの解説） */
  detailMessage: string;
}

/** チュートリアル対象ステージ番号 */
export const TUTORIAL_STAGE_NUMBER = 1;

/** チュートリアル固定ターンの最終ターン */
export const TUTORIAL_LAST_FIXED_TURN = 5;

/** ターン6以降の自由戦闘メッセージ */
export const TUTORIAL_FREE_BATTLE_MESSAGE = '自由に戦ってみよう！';

/** ターン6以降の自由戦闘詳細メッセージ */
export const TUTORIAL_FREE_BATTLE_DETAIL_MESSAGE =
  '基本操作はマスターしました！\nここからは自由にコマンドを選んで戦えます。\n2つのコマンドの組み合わせを工夫して\n勝利を目指しましょう！';

/**
 * チュートリアル固定ターン定義（ターン1〜5）
 */
export const TUTORIAL_TURNS: TutorialTurnDef[] = [
  {
    turn: 1,
    playerCommands: { first: CommandType.ADVANCE, second: CommandType.WEAPON_ATTACK },
    enemyCommands: { first: CommandType.ADVANCE, second: CommandType.ADVANCE },
    popupMessage: '前進して近づいてから武器攻撃しよう',
    detailMessage:
      'このゲームでは毎ターン2つのコマンドを選びます。\n武器攻撃は近距離でないと届きません。\n1つ目に前進して距離を詰め、\n2つ目に武器攻撃を叩き込もう！',
  },
  {
    turn: 2,
    playerCommands: { first: CommandType.WEAPON_ATTACK, second: CommandType.WEAPON_ATTACK },
    enemyCommands: { first: CommandType.RETREAT, second: CommandType.ADVANCE },
    popupMessage: '武器攻撃で攻撃しよう',
    detailMessage:
      '近距離にいる間は武器攻撃が届きます！\nただし相手が後退すると距離が離れて当たりません。\n1コマンド目は敵が後退するので外れますが、\n2コマンド目は敵が近づいてくるので当たります。',
  },
  {
    turn: 3,
    playerCommands: { first: CommandType.SPECIAL_ATTACK, second: CommandType.SPECIAL_ATTACK },
    enemyCommands: { first: CommandType.RETREAT, second: CommandType.RETREAT },
    popupMessage: '特殊攻撃は距離に関係なく当たる',
    detailMessage:
      '特殊攻撃は距離に関係なく必ず届きます。\n相手が後退して離れても命中します。\nただし武器攻撃で止めることができます。\n回数切れでも使えますが威力が大幅ダウン！',
  },
  {
    turn: 4,
    playerCommands: { first: CommandType.REFLECTOR, second: CommandType.REFLECTOR },
    enemyCommands: { first: CommandType.SPECIAL_ATTACK, second: CommandType.SPECIAL_ATTACK },
    popupMessage: 'リフレクターで特殊攻撃を跳ね返せ',
    detailMessage:
      'リフレクターは相手の特殊攻撃を反射します。\n相手が特殊攻撃を使ってきたら\nダメージを跳ね返すことができます。\n回数切れでも反射はできませんがガードは可能です。',
  },
  {
    turn: 5,
    playerCommands: { first: CommandType.STANCE_A, second: CommandType.SPECIAL_ATTACK },
    enemyCommands: { first: CommandType.ADVANCE, second: CommandType.ADVANCE },
    popupMessage: 'スタンス切替で攻撃力UP',
    detailMessage:
      'スタンスを「攻勢」に切り替えると\n攻撃力がアップする代わりに防御力がダウン。\n1stでスタンス切替、2ndで特殊攻撃の\nコンボを体験しましょう！',
  },
];
